import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const Dashboard = () => {
  // Mock State - In real app, fetch this from /api/users/me
  const [user, setUser] = useState({
    username: "alexanselm",
    password: "password123", 
    active_plan: {
      name: "Weekly Pro",
      expiry: new Date(Date.now() + 5 * 24 * 60 * 60 * 1000).toISOString(), // 5 days from now
      speed: "5 Mbps",
    },
    // Set active_plan to null to test "Inactive" state
  });

  const isActive =
    user.active_plan && new Date(user.active_plan.expiry) > new Date();

  return (
    <div className="max-w-4xl mx-auto">
      {/* Header */}
      <div className="flex justify-between items-center mb-8">
        <div>
          <h1 className="text-2xl font-bold">Hello, {user.username} 👋</h1>
          <p className="text-gray-500">Manage your internet access</p>
        </div>
        {!isActive && (
          <Link
            to="/plans"
            className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
          >
            Buy Internet
          </Link>
        )}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* Status Card */}
        <div className="bg-white p-6 rounded-lg shadow-md border-t-4 border-blue-500">
          <h2 className="text-lg font-semibold text-gray-700 mb-4">
            Subscription Status
          </h2>

          {isActive ? (
            <div className="text-center py-4">
              <div className="inline-block bg-green-100 text-green-700 px-4 py-1 rounded-full text-sm font-bold mb-2">
                ACTIVE
              </div>
              <h3 className="text-3xl font-bold text-gray-900">
                {user.active_plan.name}
              </h3>
              <p className="text-gray-500 mt-1">
                Expires:{" "}
                {new Date(user.active_plan.expiry).toLocaleDateString()}
              </p>
              <p className="text-sm text-gray-400 mt-2">
                Speed: {user.active_plan.speed}
              </p>
            </div>
          ) : (
            <div className="text-center py-6">
              <div className="inline-block bg-red-100 text-red-700 px-4 py-1 rounded-full text-sm font-bold mb-2">
                INACTIVE
              </div>
              <p className="text-gray-600">
                You do not have an active internet plan.
              </p>
              <Link
                to="/plans"
                className="text-blue-500 font-semibold mt-2 inline-block hover:underline"
              >
                View Available Plans &rarr;
              </Link>
            </div>
          )}
        </div>

        {/* Credentials Card */}
        <div className="bg-white p-6 rounded-lg shadow-md border-t-4 border-gray-800">
          <h2 className="text-lg font-semibold text-gray-700 mb-4">
            Wi-Fi Login Details
          </h2>
          <p className="text-sm text-gray-500 mb-4">
            Use these details when the "Sign into Wi-Fi" popup appears.
          </p>

          <div className="bg-gray-100 p-4 rounded mb-3">
            <span className="text-xs text-gray-500 uppercase tracking-wide">
              Username
            </span>
            <div className="text-lg font-mono font-bold text-gray-800">
              {user.username}
            </div>
          </div>

          <div className="bg-gray-100 p-4 rounded">
            <span className="text-xs text-gray-500 uppercase tracking-wide">
              Password
            </span>
            <div className="text-lg font-mono font-bold text-gray-800">
              {user.password}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
